import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '@sdbn/appclient';
import { ServiceResponse } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { BlacklistDetails } from './blacklist-administration.model';

@Injectable({
  providedIn: 'root'
})
export class BlacklistAdministrationService {

  constructor(private httpService: HttpService) { }

  public loadBlacklist(): Observable<BlacklistDetails[]> {
    return this.httpService.postWithContext(environment.blacklistAdminEndpoint, {});
  }

  public saveBlacklist(blacklist: BlacklistDetails[]): Observable<ServiceResponse> {
    return this.httpService.postWithContext(environment.blacklistAdminEndpoint + '/save', blacklist);
  }
}
